import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { Sprite, Texture } from 'pixi.js';
import { GeneralShape } from '../../element-editor/shape/shapes/general/general-shape';
import { CanvasService } from '../../services/canvas/canvas.service';
import {
  ImageData,
  LoadedImageData,
} from '../file-uploader/file-uploader.component';

const MAX_WIDTH = 820;
const MAX_HEIGHT = 520;

@Component({
  selector: 'svg-file-preview',
  templateUrl: './file-preview.component.html',
  styleUrls: ['./file-preview.component.scss'],
})
export class FilePreviewComponent {
  data: Partial<ImageData> = {
    label: '',
  };

  loading = true;

  imageIsLoaded = false;
  inProgressText = '';

  @Input()
  uuid: string;

  @Output()
  fileIsLoaded = new EventEmitter<LoadedImageData>();

  get svgWidth() {
    return this.loading ? 0 : this.data.width;
  }

  get svgHeight() {
    return this.loading ? 0 : this.data.width;
  }

  get containerWidth() {
    return Math.min(this.data.width, MAX_WIDTH);
  }

  get containerHeight() {
    return Math.min(this.data.height, MAX_HEIGHT);
  }

  @ViewChild('previewElement') previewElement: ElementRef;

  image: GeneralShape;

  constructor(
    readonly cs: CanvasService,
    public dialogRef: MatDialogRef<FilePreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: { s3Id: string },
  ) {
    if (!dialogData?.s3Id) {
      return;
    }
    console.log('dialogData', dialogData);
    this.initImage(dialogData.s3Id);
  }

  ngOnInit() {
    if (this.uuid) {
      this.initImage(this.uuid);
    }
  }

  async initImage(uuid: string) {
    // this.data = dialogData.imageData;

    // const texture = Texture.from(`${environment.backend.url}/load-image/${url}`);

    // const base64
    console.log('uuid', uuid);

    // const base64 = `data:image/gif;base64,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`;

    // const texture = await Texture.from(`${environment.backend.url}/load-image/${uuid}`);

    const { base64 } = (await this.cs.httpService.getPromise(
      `/load-image-lambda/${uuid}`,
      {},
    )) as { base64: string };

    const texture = Texture.from('data:image/gif;base64,' + base64);

    console.log('load-image ------------------');

    // const sprite = Sprite.from(texture);
    const sprite = new Sprite(texture);

    const interval = setInterval(() => {
      const { width, height } = sprite.getBounds();

      this.data.width = width;
      this.data.height = height;

      if (width > 1 && height > 1) {
        console.log('w > 1 & h > 1');
        let scale: number;
        if (width > height) {
          scale = this.containerWidth / width;
          this._w = this.containerWidth;
          this._h = height * scale;
        } else {
          scale = this.containerHeight / height;
          this._w = width * scale;
          this._h = this.containerHeight;
        }

        this.cs.app.renderer.resize(this._w, this._h);

        sprite.setTransform(0, 0, scale, scale);
        this.cs.app.stage.addChild(sprite);

        this.loading = false;
        this.previewElement.nativeElement.appendChild(this.cs.app.view);
        this.fileIsLoaded.emit({
          width,
          height,
          initialScale: scale,
        });
        clearInterval(interval);
      }
    }, 200);
  }

  _h: number;
  _w: number;

  get height() {
    return this.loading ? 120 : this._h;
  }

  get width() {
    return this.loading ? 350 : this._w;
  }
}
